import { Alert } from "@mui/material";
import { useQuery } from "react-query";
import { Route, Routes, useParams } from "react-router-dom";
import React from "react";
import ActionLoader from "../../components/UI/ActionLoader/ActionLoader";
import { Feature } from "../../models/api";
import { fetchServices } from "../../framework/services";
import { Resources } from "constants/enums";
import Admins from "Pages/Admins";
import Plans from "Pages/Plans";
import Services from "Pages/Services";
import Notifications from "Pages/Notifications";
import ClientsList from "Pages/Clients";
import Resellers from "Pages/Resellers";
import Subscription from "Pages/Subscription";
interface Props {}

const Listing: React.FC<Props> = () => {
  let { slug } = useParams<{ slug: string }>();
  const { data, isError, isLoading } = useQuery<Feature[]>(
    "features",
    fetchServices
  );
  if (isLoading) return <ActionLoader position="fixed" />;
  if (isError)
    return (
      <Alert severity="error">
        Something went wrong, please try again later.
      </Alert>
    );
  let feature: Feature | undefined = data?.find(
    (feature) =>
      feature.slug === slug ||
      feature.children.some((child) => child.slug === slug)
  );
  if (feature?.children?.length! > 0)
    feature = feature?.children.find((child) => child.slug === slug);
  if (!feature) return <Alert severity="error">404 - Page not found</Alert>;


  const renderEditForm = () => {
    if (!feature) return null;
  };

  const renderList = () => {
    if (!feature) return null;
    if (feature.slug === Resources.PLANS) return <Plans feature={feature} />;
    if (feature.slug === Resources.ADMINS) return <Admins feature={feature} />;
    if (feature.slug === Resources.SERVICES) return <Services feature={feature} />;
    if (feature.slug === Resources.NOTIFICATIONS) return <Notifications feature={feature} />;
    if (feature.slug === Resources.CLIENTS) return <ClientsList feature={feature} />;
    if (feature.slug === Resources.RESELLER) return <Resellers feature={feature} />;
    if (feature.slug === Resources.SUBSCRIPTION) return <Subscription feature={feature} />;

  };

  return (
    <>
      <Routes>
        <Route path="/*" element={renderList()} />
        {/* <Route path="new" element={renderCreateForm()} /> */}
        <Route path={`:${feature.singleName}Id/*`} element={renderEditForm()} />
      </Routes>
    </>
  );
};

export default Listing;
